import { Component, OnInit } from '@angular/core';
import { BrapiSyncContextService } from '../brapi-sync-context.service';
import { HttpClient } from '@angular/common/http';
import { DelegatedAuthenticationService } from '../../shared/oauth-oidc-client/delegated-authentication.service';
import { BRAPI_SYNC_BASE_URL_PLACEHOLDER } from '../app.constants';
import { AlertService } from '../../shared/alert/alert.service';
import { CropParameterService } from '../../shared/crop-parameter/service/crop-parameter.service';
import { CropParameterTypeEnum } from '../../shared/crop-parameter/model/crop-parameter-type-enum';
import { ParamContext } from '../../shared/service/param.context';
import { CropParameter } from '../../shared/crop-parameter/model/crop-parameter';
import { BrapiSyncPath, BrapiSyncService } from '../brapi-sync.service';

declare const BrAPI: any;

@Component({
    selector: 'app-connections',
    templateUrl: './connections.component.html',
    styleUrls: ['./connections.component.css']
})
export class ConnectionsComponent implements OnInit {

    BRAPI_SYNC_BASE_URL_PLACEHOLDER = BRAPI_SYNC_BASE_URL_PLACEHOLDER;

    authenticationType = AuthenticationType;

    loading = false;

    sourceSuccess: boolean | null = null;
    destSuccess: boolean | null = null;

    sourceAuth = AuthenticationType.DELEGATED;
    destinationAuth = AuthenticationType.DELEGATED;

    tokenToStore = '';

    constructor(
    public context: BrapiSyncContextService,
    private cropParameterService: CropParameterService,
    private http: HttpClient,
    private delegatedAuthenticationService: DelegatedAuthenticationService,
    private alertService: AlertService,
    private paramContext: ParamContext,
    private brapiSyncService: BrapiSyncService
    ) {
    }

    async ngOnInit(): Promise<void> {

        this.destinationAuth = AuthenticationType.TOKEN;
        this.context.destination = `${window.location.origin}/bmsapi/${this.paramContext.cropName}/brapi/v2`;
        await this.cropParameterService.getCropParameter(this.paramContext.cropName, this.paramContext.programUUID, CropParameterTypeEnum.DEFAULT_BRAPI_SYNC_SOURCE)
            .toPromise()
            .then((cropParameter: CropParameter) => {
                if (cropParameter.value) {
                    this.context.source = cropParameter.value;
                }
            });
    }

    async loginSource(): Promise<void> {
        this.removeTrailingSlashes();
        if (this.context.source) {
            this.tokenToStore = 'source';
            this.context.sourceToken = await this.delegatedAuthenticationService.login(this.context.source);
            this.sourceSuccess = true;
        } else {
            this.alertService.error('brapi-sync.connections.error.specify-source-url');
        }
    }

    async loginDestination(): Promise<void> {
        this.removeTrailingSlashes();
        if (this.context.destination) {
            this.tokenToStore = 'destination';
            this.context.destinationToken = await this.delegatedAuthenticationService.login(this.context.destination);
            this.destSuccess = true;
        } else {
            this.alertService.error('brapi-sync.connections.error.specify-destination-url');
        }
    }

    async next(): Promise<void> {

        this.removeTrailingSlashes();

        // TODO verify only v2 endpoints
        this.loading = true;
        try {
            await this.http.get(this.context.source + '/serverinfo').toPromise();
            this.sourceSuccess = true;
        } catch (e) {
            this.sourceSuccess = false;
        }

        try {
            await this.http.get(this.context.destination + '/serverinfo').toPromise();
            this.destSuccess = true;
        } catch (e) {
            this.destSuccess = false;
        }

        this.loading = false;

        if (this.sourceSuccess && this.destSuccess) {
            this.brapiSyncService.navigateToPage(BrapiSyncPath.Program);
        } else {
            this.alertService.error('brapi-sync.connections.error.cannot-proceed');
        }

    }

    /**
   * Some servers (e.g breedbase catalyst) won't accept double slash //
   */
    removeTrailingSlashes(): void {
        this.context.source = this.context.source.replace(/\/+$/, '');
        this.context.destination = this.context.destination.replace(/\/+$/, '');
    }

}

enum AuthenticationType {
  DELEGATED = 'delegated',
  TOKEN = 'token',
  CREDENTIALS = 'credentials'
}

